import addMilliseconds from 'date-fns/addMilliseconds';

export function getTrialEndDate(timeLeft?: number | null): Date | undefined {
	if (timeLeft === null || timeLeft === undefined) {
		return undefined;
	}

	if (timeLeft <= 0) {
		return undefined;
	}

	return addMilliseconds(Date.now(), timeLeft);
}
